import * as React from 'react';
import styled from 'styled-components';

import { getSemanticAttributes } from '../../internals/semanticProps';
import { rem } from '../../tokens/spacing';

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: string;
  align?: 'stretch' | 'start' | 'center' | 'end';
  semanticId?: string;
}

const alignMap: Record<NonNullable<StackProps['align']>, string> = {
  stretch: 'stretch',
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

const shouldForward = (prop: string | number): boolean => !['$gap', '$align'].includes(String(prop));

const StyledStack = styled.div.withConfig({ shouldForwardProp: shouldForward })<{
  $gap: string;
  $align: string;
}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => $align};
  gap: ${({ $gap }) => $gap};
`;

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(function Stack(
  { gap = `var(--ui-space-md, ${rem(16)})`, align = 'stretch', semanticId, ...rest },
  ref,
) {
  const semanticProps = getSemanticAttributes(semanticId);

  return (
    <StyledStack
      ref={ref}
      $gap={gap}
      $align={alignMap[align]}
      {...semanticProps}
      {...rest}
    />
  );
});

Stack.displayName = 'Stack';
